import { AutocompleteRenderGetTagProps, Chip } from "@mui/material";
import { CloseCancelErrorIcon, neutral } from "@flat-ui";
import { getSvgColoredIconCss } from "@utils/ui-utils";

type ChipTagProps = {
  /** Internal props for the chip provided by autocomplete component */
  tagProps: AutocompleteRenderGetTagProps;

  /** The index of the current chip being processed in the chip list */
  index: number;

  /** Text displayed in the chip */
  label: string;

  /** True when the chip should be disabled */
  isDisabled?: boolean;

  /** Callback function to validate new inserted value before adding to the chip */
  validateNewItem?(item: string): boolean;

  /** Additional CSS class name to apply to the chip */
  className?: string;
};

/** Renders chip with cross button */
export function ChipTag({
  tagProps,
  index,
  label,
  isDisabled,
  className = "",
}: ChipTagProps): JSX.Element | null {
  return (
    <Chip
      {...tagProps({ index })}
      key={`chip-${index}`}
      label={label}
      className={className}
      sx={{
        color: neutral[0],
        background: neutral[400],
        height: "25px",
        fontSize: "12px",
        cursor: "default",
        "& .MuiChip-deleteIcon": {
          ...getSvgColoredIconCss(neutral[0]),
        },
        "& .MuiChip-deleteIcon:hover": {
          ...getSvgColoredIconCss(neutral[0]),
        },
      }}
      disabled={isDisabled}
      // Only show delete icon if the chip is not disabled
      deleteIcon={
        isDisabled ? undefined : (
          <CloseCancelErrorIcon key={`chip-delete-${index}`} />
        )
      }
    />
  );
}
